export const config = {
  clinic: {
    id: import.meta.env.VITE_CLINIC_ID,
    fullName: import.meta.env.VITE_CLINIC_FULLNAME,
    shortName: import.meta.env.VITE_CLINIC_SHORTNAME,
    location: {
      lat: parseFloat(import.meta.env.VITE_CLINIC_LAT),
      lng: parseFloat(import.meta.env.VITE_CLINIC_LNG),
    },
  },
  appointments: {
    slotDuration: parseInt(import.meta.env.VITE_SLOT_DURATION),
    startTime: import.meta.env.VITE_START_TIME,
    workingHours: parseInt(import.meta.env.VITE_WORKING_HOURS),
    workingDaysHash: import.meta.env.VITE_WORKING_DAYS_HASH,
    daysRange: parseInt(import.meta.env.VITE_DAYS_RANGE),
  },
} as const;

// Usage example:
//import { config } from "@/config/environment";
//console.log(config.clinic.fullName);
//console.log(config.appointments.slotDuration);
